import { Component, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

/**
 * LoadingComponent
 */
@Component({
    selector: 'rttd-loading',
    templateUrl: './loading.component.html',
    styles: [
        require('./loading.component.scss').default.toString(),
        require(`./loading.component.${environment.brand}.scss`).default.toString()
    ],
})
@Injectable()
export class LoadingComponent {

    /**
     * @ignore
     */
    static isLoading: boolean;

    /**
     * @ignore
     */
    static isError: boolean;

    /**
     * @ignore
     */
    static errorMessage: string;

    /**
     * @ignore
     */
    public LoadingComponent = LoadingComponent;

    /**
     * @ignore
     */
    constructor() {
        LoadingComponent.isLoading = true;
        LoadingComponent.isError = false;
    }

    /**
     * @description Toggles loading wheel
     * @param isLoading boolean to toggle
     */
    static setStatus(isLoading: boolean) {
        LoadingComponent.isLoading = isLoading;
    }

    /**
     * @description Sets error toggle and error message
     * @param isError is a boolean
     * @param errorMessage should be an object with statusText of string
     */
    static setErrorStatus(isError: boolean, errorMessage: any) {
        // Force digest
        setTimeout(() => {
            LoadingComponent.setStatus(false);
            LoadingComponent.isError = isError;
            LoadingComponent.errorMessage = errorMessage.statusText;
        }, 0);
    }

}
